import React, { useState, useRef } from 'react';
import { QRCode, Space, Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import Menu from '../../components/Menu/Menu';
import { REACT_APP_URL } from '../../Constants'
import './Sharing.scss'

const Setting = () => {
    const apiUrl = REACT_APP_URL

    const [size, setSize] = useState(160);
    const user = JSON.parse(localStorage.getItem('user'));
    const increase = () => {
        setSize((prevSize) => {
            const newSize = prevSize + 10;
            if (newSize > 300) {
                return 300;
            }
            return newSize;
        });
    };
    const decline = () => {
        setSize((prevSize) => {
            const newSize = prevSize - 10;
            if (newSize < 48) {
                return 48;
            }
            return newSize;
        });
    };

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const downloadQRCode = () => {
        const canvas = document.getElementById('qrcode')?.querySelector('canvas');
        if (canvas) {
            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }
    return (
        <div className='outer-container'>
            <div className='container mt-5 d-flex justify-content-between'>
                <Menu />
                <div className='d-flex align-items-center sharing-title'>SETTING</div>
            </div>
            <div className="sharing-container" id='qrcode'>
                <br />

                <Button.Group
                    style={{
                        marginBottom: 16,
                    }}
                >
                    <Button onClick={decline} disabled={size <= 96} icon={<MinusOutlined />}>
                        Smaller
                    </Button>
                    <Button onClick={increase} disabled={size >= 300} icon={<PlusOutlined />}>
                        Larger
                    </Button>
                </Button.Group>
                <span>{user?.user_name}</span>

                <Space direction="vertical" size={size}>
                    <QRCode value={`${apiUrl}login/${storedUser.user_id}`} size={size} />
                </Space>
                <br />
                <span className='small-text'>Scan the QRCode to signup AskWei.</span>
                <br />
                <Button type="primary" className='download-button' onClick={downloadQRCode}>
                    Download
                </Button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => (
    {
        user: state.auth.user
    }
);


//   export default connect(mapStateToProps)(Setting);
export default (Setting);